import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { createSafeStorage } from "./safeStorage";

export type TutorialStatus = "not_started" | "in_progress" | "completed" | "skipped";
export type TutorialHintId = "skills" | "tools";

interface TutorialState {
  status: TutorialStatus;
  stepIndex: number;
  seenHints: TutorialHintId[];
}

interface TutorialActions {
  start: () => void;
  goTo: (stepIndex: number) => void;
  skip: () => void;
  complete: () => void;
  markHintSeen: (id: TutorialHintId) => void;
  reset: () => void;
}

export type TutorialStore = TutorialState & TutorialActions;

const INITIAL: TutorialState = { status: "not_started", stepIndex: 0, seenHints: [] };

export const useTutorialStore = create<TutorialStore>()(
  persist<TutorialStore, [], [], TutorialState>(
    (set) => ({
      ...INITIAL,
      start: () => set(() => ({ status: "in_progress", stepIndex: 0, seenHints: [] })),
      goTo: (stepIndex) => set(() => ({ stepIndex })),
      skip: () => set(() => ({ status: "skipped" })),
      complete: () => set(() => ({ status: "completed" })),
      markHintSeen: (id) =>
        set((state) => ({
          seenHints: state.seenHints.includes(id) ? state.seenHints : [...state.seenHints, id],
        })),
      reset: () => set(() => ({ ...INITIAL })),
    }),
    {
      name: "bg_tutorial",
      storage: createJSONStorage(() => createSafeStorage()),
      partialize: (state) => ({
        status: state.status,
        stepIndex: state.stepIndex,
        seenHints: state.seenHints,
      }),
    },
  ),
);
